// PurchaseOrderViewContent Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Acl from '../../../lib/acl.jsx'
import PurchaseOrderViewItem from '../purchaseorder_viewitem/purchaseorder_viewitem.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class PurchaseOrderViewContent extends Component {
  static get propTypes () {
    return {
      purchaseorder: PropTypes.object,
      onUpdateItem: PropTypes.func,
      onDeleteItem: PropTypes.func,
      item: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      purchaseorder: null,
      onUpdateItem: null,
      onDeleteItem: null,
      item: null
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      showEdit: null,
      dataDate: null,
      itemTotal: (props.item && props.item.total) || 0
    }
  }

  render () {
    const purchaseOrder = this.props.purchaseorder
    const className = `viewtotal${
      purchaseOrder.status === 'Closed' ? ' alt' : ''
    }`

    if (!purchaseOrder) {
      return (
        <div className='purchaseorder-viewcontent'>
          <div className='contwrap'>{this._renderHeader()}</div>
        </div>
      )
    }

    return (
      <div className='purchaseorder-viewcontent'>
        <div className='contwrap'>
          {this._renderHeader()}

          <div className='viewitems'>{this._renderItems()}</div>
          <div className={className}>
            <div className='viewcol colname'>
              {purchaseOrder.status !== 'Closed' && (
                <p className='info'>
                  <i className='icon icon-purchaseorder-info' />
                  <IntlMessage ident='expense.view.poInfo' />
                </p>
              )}
            </div>
            <div className='viewcol colproject'>
              <div className='totallbl'>
                <IntlMessage ident='expense.view.labelTotal' />
              </div>
            </div>
            <div className='viewcol colprice'>
              <h2 className='moneyvalue'>
                <span className='value'>
                  <PriceText value={purchaseOrder.total} />
                </span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    )
  }

  /* Private Functions */
  _renderHeader () {
    return (
      <div className='viewheader'>
        <div className='viewcol colname'>
          <IntlMessage ident='expense.view.labelName' />
        </div>
        <div className='viewcol colproject'>
          <IntlMessage ident='expense.view.labelProject' />
        </div>
        <div className='viewcol colprice'>
          <IntlMessage ident='expense.view.labelPrice' />
        </div>
      </div>
    )
  }

  _renderItems () {
    if (!this.props.purchaseorder.items) {
      return ''
    }

    const bEdit =
      this.props.purchaseorder.status === 'Draft' ||
      (this.props.purchaseorder.status === 'Open' &&
        Acl.isRoleProjectManager())

    return this.props.purchaseorder.items.map((item, itemIdx) =>
      this._renderItem(item, itemIdx, bEdit)
    )
  }

  _onChangeItemInput (item, value, name) {
    if (name === 'total') {
      this._onChangeTotal(item, value)
    } else if (name === 'description') {
      this._onChangeActivityDesc(item, value)
    } else if (name === 'title') {
      item.title = value
      this.setState({ dataDate: new Date() })
    }
  }

  _onBlurItemInput (item, value, name) {
    if (name === 'total') {
      this._onBlurTotal()
    } else if (name === 'title') {
      this._handleActivityTitleBlur(item)
    } else if (name === 'description') {
      this._handleActivityDescBlur(item, value)
    }
  }

  _renderItem (item, itemIdx, bEdit) {
    return (
      <PurchaseOrderViewItem
        showEdit={bEdit}
        key={`${item.id}-${itemIdx}`}
        item={item}
        itemIdx={itemIdx}
        editId={this.state.showEdit}
        onClickItem={this._onClickItem.bind(this, item)}
        onChangeInput={this._onChangeItemInput.bind(this)}
        onBlurInput={this._onBlurItemInput.bind(this)}
        itemTotal={this.state.itemTotal}
        onDelete={this._onDelete.bind(this)}
      />
    )
  }

  _onClickItem (item) {
    this.setState({
      showEdit: item.id,
      itemTotal: item.total || 0,
      dataDate: new Date()
    })
  }

  _onDelete (delItem) {
    let showEdit = this.state.showEdit
    if (this.state.showEdit === delItem.id) {
      showEdit = null
    }

    if (this.props.onDeleteItem) {
      this.props.onDeleteItem(delItem)
    }

    this._refresh(showEdit)
  }

  _onBlurTotal () {
    this._refresh(null)
  }

  _onChangeTotal (item, value) {
    item.total = value

    if (this.props.onUpdateItem) {
      this.props.onUpdateItem(item, true)
    }

    this.setState({ itemTotal: value })
  }

  _onChangeActivityDesc (item, value) {
    item.description = value
    this.setState({ dataDate: new Date() })
  }

  _handleActivityDescBlur (item, value) {
    item.description = value

    if (this.props.onUpdateItem) {
      this.props.onUpdateItem(item, false, ['description'])
    }
  }

  _handleActivityTitleBlur (item) {
    if (this.props.onUpdateItem) {
      this.props.onUpdateItem(item, false, ['title'])
    }
  }

  _refresh (showEdit) {
    this.setState({ showEdit: showEdit, dataDate: new Date() })
  }
}

export default PurchaseOrderViewContent
